/**
 * @generated SignedSource<<3bacca603b5d1b5a6b8824c0cac9509e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PracticeResult = "RECURRED" | "TARGETED" | "USED_CORRECTLY" | "%future added value";
export type ActivityFeedQuery$variables = {
  itemId: string;
};
export type ActivityFeedQuery$data = {
  readonly me: {
    readonly learner: {
      readonly sessions: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly practice: ReadonlyArray<{
            readonly item: {
              readonly exemplar: {
                readonly targetForm: string;
              } | null | undefined;
              readonly id: string;
              readonly pattern: string;
            };
            readonly outcome: PracticeResult;
          }>;
          readonly startedAt: any;
        }>;
      };
    } | null | undefined;
  } | null | undefined;
  readonly practiceItem: {
    readonly id?: string;
  } | null | undefined;
};
export type ActivityFeedQuery = {
  response: ActivityFeedQuery$data;
  variables: ActivityFeedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 50
    }
  ],
  "concreteType": "SessionConnection",
  "kind": "LinkedField",
  "name": "sessions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Session",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PracticeOutcome",
          "kind": "LinkedField",
          "name": "practice",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PracticeItem",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pattern",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Exemplar",
                  "kind": "LinkedField",
                  "name": "exemplar",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "targetForm",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "outcome",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "sessions(first:50)"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "itemId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivityFeedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "practiceItem",
        "args": (v3/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v1/*:: as any*/)
            ],
            "type": "PracticeItem",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ActivityFeedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v1/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "practiceItem",
        "args": (v3/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "005a4d253c9ef1a07e56aabbd3d18509",
    "id": null,
    "metadata": {},
    "name": "ActivityFeedQuery",
    "operationKind": "query",
    "text": "query ActivityFeedQuery(\n  $itemId: ID!\n) {\n  me {\n    learner {\n      sessions(first: 50) {\n        nodes {\n          id\n          startedAt\n          practice {\n            item {\n              id\n              pattern\n              exemplar {\n                targetForm\n              }\n            }\n            outcome\n          }\n        }\n      }\n      id\n    }\n  }\n  practiceItem: node(id: $itemId) {\n    __typename\n    ... on PracticeItem {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7012d8baec7616891291c325ff2cd00";

export default node;
